import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/main.css'
import './css/common.css'
import './css/payment.css'
import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount, TotalAmountCount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import html2canvas from 'html2canvas';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDateSplit, SearchDateSplitMobile, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from './component/search/search';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { formatDateTime, changeNum, datePickerCommonOpts, paintWeekendColors } from './common/function';
import useWindowSize from './hook/useWindowSize'

dayjs.extend(utc);
dayjs.extend(timezone);
const toKST = (s) => dayjs.utc(s).tz('Asia/Seoul');

function Withdraw() {
    let navigate = useNavigate();
    let dispatch = useDispatch()

    const { Rwidth, Rheight } = useWindowSize();

    const [loading, setLoading] = useState(true)
    const [message, setMessage] = useState({ msg: "" })
    const [page, setPage] = useState(1)
    const [totalPage, setTotalPage] = useState(0)
    const [maxFirstPage, setMaxFirstPage] = useState(40)

    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [reload, setReload] = useState(false)


    useEffect(() => {
        dispatch(change_Current_Location("입출금내역"))
        dispatch(changeHeaderTitle({
            mainTitle: "입출금내역",
            subTitle: ""
        }))
        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const handleChangeMaxPage = (event) => {
        setMaxFirstPage(Number(event.target.value));
    };

    // 기간 포맷 - 시작일/종료일 개별 선택
    const startInputRef = useRef(null);
    const endInputRef = useRef(null);
    const startPickerRef = useRef(null);
    const endPickerRef = useRef(null);

    // 날짜 상태 (초기값: 이번 달)
    const [preDate, setPreDate] = useState(dayjs().startOf('month').format('YYYY/MM/DD'));
    const [nextDate, setNextDate] = useState(dayjs().endOf('month').format('YYYY/MM/DD'));

    // 뷰포트 전환(데스크톱 ↔ 모바일) 시 재부착
    useEffect(() => {
        const startEl = startInputRef.current;
        const endEl = endInputRef.current;
        if (!startEl || !endEl) return;

        if (startPickerRef.current) { startPickerRef.current.destroy(); startPickerRef.current = null; }
        if (endPickerRef.current) { endPickerRef.current.destroy(); endPickerRef.current = null; }

        startPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: startEl,
            setup: (p) => {
                p.on('render', paintWeekendColors);
                p.on('selected', (date) => {
                    setPreDate(date.format('YYYY/MM/DD'));
                    setPage(1);
                });
            },
        });
        endPickerRef.current = new Litepicker({
            ...datePickerCommonOpts,
            element: endEl,
            setup: (p) => {
                p.on('render', paintWeekendColors);
                p.on('selected', (date) => {
                    setNextDate(date.format('YYYY/MM/DD'));
                    setPage(1);
                });
            },
        });

        startPickerRef.current.setDate(preDate);
        endPickerRef.current.setDate(nextDate);

        return () => {
            startPickerRef.current?.destroy();
            endPickerRef.current?.destroy();
            startPickerRef.current = null;
            endPickerRef.current = null;
        };
    }, [Rwidth]);

    // 날짜 상태가 바뀌면 picker에도 반영
    useEffect(() => {
        startPickerRef.current?.setDate(preDate);
        endPickerRef.current?.setDate(nextDate);
    }, [preDate, nextDate]);

    // 공용 setter (당일/전일/당월/전월 버튼에서 호출)
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        startPickerRef.current?.setDate(startDate);
        endPickerRef.current?.setDate(endDate);
        setPage(1);
    };

    useEffect(() => {
        ListData()
    }, [page, preDate, nextDate, maxFirstPage])

    const ListData = async () => {
        if (page == 1) setLoading(true)
        await axios.get(process.env.REACT_APP_API + "/api/user-wallet/transactions", {
            withCredentials: true,
            params: {
                // DEPOSIT, WITHDRAW
                txType: "",
                startDate: preDate,
                endDate: nextDate,
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                if (page === 1) {
                    setListData(tmp?.data?.transactions ?? []);
                }
                else {
                    setListData((prev) => [...prev, ...tmp?.data?.transactions ?? []]);
                }
                setTotalPage(tmp?.data?.pagination?.totalItems ?? 0)
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setLoading(false)
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        { "no": 1, "text": "상태", "width": "70px", "textAlign": "center" },
        { "no": 2, "text": "금액", "width": "85px", "textAlign": "center" },
        { "no": 2, "text": "잔액", "width": "85px", "textAlign": "center" },
        { "no": 6, "text": "일시", "width": "120px", "textAlign": "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let list = listData ?? []

            for (let i = 0; i < list.length; i++) {
                let data = list[i];

                const dateTimeStr = toKST(data.completed_at ?? data.created_at ?? "").format("YYYY-MM-DD HH:mm:ss");
                const amountNum = Number(data.amount);
                const amountText = data.tx_type === "WITHDRAW"
                    ? "-" + changeNum(Math.abs(amountNum))
                    : changeNum(amountNum);
                tableBodyData.push([
                    { "no": 1, "text": data.tx_type == "WITHDRAW" ? "출금" : "입금", "width": "70px", "textAlign": "center" },
                    { "no": 2, "text": amountText, "width": "85px", "textAlign": "right" },
                    { "no": 2, "text": changeNum(Number(data.balance_after)), "width": "85px", "textAlign": "right" },
                    { "no": 1, "text": dateTimeStr, "width": "120px", "textAlign": "center" },
                ])
            }

            setCombineData(tableBodyData)
        }
    }, [listData, reload]);

    const excelBtn = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/sugi", {
            withCredentials: true,
            params: {

            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                excelData(tmp?.data?.sugi ?? [])
            }
        }).catch(error => {
            console.error(error);
            setMessage({ msg: "엑셀 데이터 조회 중 오류가 발생했습니다." });
        });
    }

    const excelData = (exData) => {
        let arr = []

        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]

                try {
                    arr.push({
                        "NO": i + 1,
                        "MID": t.mid,
                        "거래일시": t.trx_date,
                        "취소일시": t.cancel_date,
                        "거래상태": t.state == '1' ? "승인" : t.status == '2' ? "매입전취소" : "매입후취소",
                        "거래금액": `${Number(t.amt).toLocaleString()}원`,
                        "결제서비스": t.payment_service,
                        "결제구분": t.payment_type,
                        "구매자명": t.buyer_nm,
                        "카드": t.card,
                        "할부": t.quota === "00" ? "일시불" : `${t.quota}개월`,
                        "상품명": t.prd_nm,
                        "주문번호": t.order_id,
                        "거래번호": t.trx_id,
                    })
                } catch (error) {
                    // error
                }
            }
        }
        Excel(arr)
    }

    const isMobile = Rwidth <= 767;

    // 스크롤 컨테이너(모바일 영역) 참조
    const mobileScrollRef = useRef(null);

    // observer 인스턴스 보관
    const ioRef = useRef(null);

    // sentinel을 바꿀 때마다 자동으로 observe/cleanup 되는 콜백 ref
    const setSentinelRef = useCallback((node) => {
        // 이전 관찰 중단
        if (ioRef.current) {
            ioRef.current.disconnect();
            ioRef.current = null;
        }
        if (!node) return;

        // root: 모바일은 내부 스크롤 박스, 데스크톱은 기본(뷰포트 또는 외부 스크롤러)
        const rootEl = isMobile ? mobileScrollRef.current : null;

        ioRef.current = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && totalPage >= page * maxFirstPage) {
                setPage((prev) => prev + 1);
            }
        }, {
            root: rootEl,            // 중요: 모바일에서 내부 스크롤 컨테이너 지정
            rootMargin: "200px 0px", // 여유롭게 미리 로드
            threshold: 0
        });

        ioRef.current.observe(node);
    }, [isMobile, totalPage, page, maxFirstPage]);

    // list 변경·레이아웃 전환 시에도 sentinel 재연결 보장 (콜백 ref가 처리하지만 안전망)
    useEffect(() => {
        return () => { ioRef.current?.disconnect(); };
    }, []);

    const sortedList = useMemo(
        () => [...listData].sort((a, b) => {
            const aAt = a.completed_at ?? a.created_at ?? "";
            const bAt = b.completed_at ?? b.created_at ?? "";
            return toKST(bAt) - toKST(aAt);
        }),
        [listData]
    );

    // 선택 기간 내 입출금 합계 (입금 +, 출금 -)
    const depositWithdrawSum = useMemo(
        () => listData.reduce((acc, item) => acc + Number(item.amount ?? 0), 0),
        [listData]
    );

    let lastKey = null;

    const dateKey = (s) => toKST(s).format("YY.MM.DD"); // 예: 25.08.01
    const timeStr = (s) => toKST(s).format("HH:mm");    // 예: 12:45

    return (
        <>
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />
            {
                Rwidth > 767
                    ?
                    <div class="content" id="contents">
                        <div class="paylist">
                            <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
                                <div class="form_filter w-full">
                                    <SearchDateSplit
                                        startInputRef={startInputRef}
                                        endInputRef={endInputRef}
                                        setDateRange={setDateRange}
                                        preDate={preDate}
                                        nextDate={nextDate}
                                    />
                                </div>
                            </form>
                            <div className="intro-y box p-5 mt-2">
                                {/* <div className="tabulator_sorting_wrap">
                        <DownloadBtn text={"엑셀 다운로드"} onClick={excelBtn} />
                        <CountSelect onChange={handleChangeMaxPage} maxFirstPage={maxFirstPage} />
                    </div> */}
                                <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end' }}>
                                    <CountAmount tableBodyData={totalPage ?? 0} />
                                </div>
                                <div style={{ maxWidth: "500px", width: "100%" }}>
                                    <List
                                        tableHeaderData={tableHeaderData}
                                        tableBodyData={totalPage ?? 0}
                                        filter_tableBodyData={combineData}
                                        page={page}
                                        setPage={setPage}
                                        maxFirstPage={maxFirstPage}
                                        nonePage={false}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <div style={{ marginTop: "3.5rem", background: "#fff", minHeight: "calc(100dvh - 3.5rem)" }}>
                        <div style={{ padding: "20px 15px", borderBottom: "6px solid #f1f1f1" }}>
                            <SearchDateSplitMobile
                                startInputRef={startInputRef}
                                endInputRef={endInputRef}
                                setDateRange={setDateRange}
                                preDate={preDate}
                                nextDate={nextDate}
                            />
                        </div>
                        <div style={{ padding: "15px 15px 10px", borderBottom: "6px solid #f1f1f1" }}>
                            <div style={{ fontSize: "13px", color: "#a9a9ab", fontWeight: "500", marginBottom: "3px" }}>{`${preDate}~${nextDate}`}</div>
                            <div style={{ padding: "20px 12px", background: "#f5f6f8", borderRadius: "8px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    <div>입출금 합계</div>
                                    <div>
                                        <span style={{ color: depositWithdrawSum >= 0 ? "#000" : "#d52424" }}>{depositWithdrawSum >= 0 ? "" : "-"}{changeNum(Math.abs(depositWithdrawSum))}</span>
                                        <span style={{ marginLeft: "2px" }}>원</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ padding: "0px", borderBottom: "6px solid #f1f1f1", height: "calc(100dvh - 310px)", overflow: "scroll" }}>
                            {sortedList.map((item, i) => {
                                const dateTime = item.completed_at ?? item.created_at ?? "";
                                const dKey = dateKey(dateTime);
                                const tStr = timeStr(dateTime);
                                const showHeader = dKey !== lastKey;
                                lastKey = dKey;

                                return (
                                    <Fragment key={item.id ?? item.trx_id ?? i}>
                                        {showHeader &&
                                            <div
                                                style={{
                                                    background: "#f1f1f1",
                                                    textAlign: "center",
                                                    padding: "4px",
                                                    fontWeight: "500"
                                                }}
                                            >{dKey}</div>}

                                        {/* 시간만 왼쪽에 찍고 싶다면 timeStr을 prop으로 넘기세요 */}
                                        <MobileListItem
                                            item={item}
                                        />
                                    </Fragment>
                                );
                            })}
                            <div ref={setSentinelRef} style={{ height: '1px' }}></div>
                        </div>
                    </div>
            }
        </>
    )
}

function MobileListItem({ item }) {
    const raw = item.completed_at ?? item.created_at ?? ""; // completed_at이 null이면 created_at 사용
    const kst = toKST(raw);

    // 날짜: 2025-08-01 → 25.08.01
    const dateStr = kst.format("YY.MM.DD");

    // 시간: 12:45:15 → 12:45
    const timeStr = kst.format("HH:mm");

    return (
        <div style={{
            display: "flex",
            gap: "15px",
            borderBottom: "1px solid #f1f1f1",
            padding: "15px",
            position: "relative"
        }}>
            <div style={{ fontSize: "13px", color: "#82898f", textAlign: "right" }}>
                <div style={{ height: "15px" }}>{timeStr}</div>
            </div>
            <div style={{ width: "100%" }}>
                <div style={{ fontSize: "13px", fontWeight: "500", display: "flex", justifyContent: "space-between" }}>
                    <div>
                        [{item.tx_type == "WITHDRAW" ? "출금" : "입금"}] {item.accnt_nm}
                    </div>
                    <div style={{ fontSize: "14px", fontWeight: "600", color: item.tx_type == "WITHDRAW" ? "red" : "green" }}>{item.tx_type == "WITHDRAW" ? "-" : "+"}{changeNum(Math.abs(Number(item.amount)))}원</div>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ fontSize: "10px", color: "#82898f", height: "15px" }}>
                        {item.bank_nm}
                        <span style={{ margin: "0 5px", fontWeight: "600", fontSize: "13px", color: "#000" }}>|</span>
                        {item.accnt_no}
                    </div>
                    <div style={{ fontSize: "12px", fontWeight: "500", color: "#999" }}>
                        {changeNum(Number(item.balance_after))}원
                    </div>
                </div>
            </div>
        </div>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `거래내역`;

    const ws = XLSX.utils.aoa_to_sheet([
        [
            "NO", "MID", "거래일시", "취소일시", "거래상태", "거래금액", "결제서비스", "결제구분", "구매자명", "카드", "할부", "상품명", "주문번호", "거래번호"
        ]
    ]);
    excelData.map((data) => {
        XLSX.utils.sheet_add_aoa(
            ws,
            [
                [
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.NO },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.MID },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.취소일시 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래상태 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래금액 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.결제서비스 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.결제구분 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.구매자명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.카드 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.할부 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.상품명 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.주문번호 },
                    { t: 's', s: { alignment: { horizontal: 'center' } }, v: data.거래번호 }
                ]
            ],
            { origin: -1 }
        );
        ws['!cols'] = [
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 },
            { wpx: 100 }
        ]
        return false;
    });
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelButter = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelButter], { type: excelFileType });
    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default Withdraw;